import type { RetrievalRun } from '../../../api/retrievals'
import type { Source } from '../../../api/sources'

/** Return the newest run for each enabled source while preserving newest-first order. */
export function latestRunPerActiveSource(
  runs: RetrievalRun[],
  sources: Pick<Source, 'id' | 'enabled'>[],
): RetrievalRun[] {
  const enabledSourceIds = new Set(
    sources.filter((source) => source.enabled).map((source) => source.id),
  )
  const seenSourceIds = new Set<number>()
  return runs.filter((run) => {
    // If source metadata has not loaded, still render the newest run per source.
    if (enabledSourceIds.size > 0 && !enabledSourceIds.has(run.sourceId)) return false
    if (seenSourceIds.has(run.sourceId)) return false
    seenSourceIds.add(run.sourceId)
    return true
  })
}
